import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BaseControl } from '../base/base-control';

@Component({
    selector: 'app-checkbox',
    standalone: true,
    templateUrl: './checkbox.component.html',
    styleUrl: './checkbox.component.scss',
    imports: [MatCheckboxModule],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }]
})
export class CheckboxComponent extends BaseControl<boolean> { }